export default __webpack_public_path__ + "static/media/illustration-study-1-m@2x.db70eb63.webp";